import { CCard, CCardBody, CCardTitle } from "@coreui/react";
import SafetyMessage from "../components/safety/SafetyMessage";
import { useEffect, useState } from "react";
import CookieFunctions from "../functions/CookieFunctions";
import { toast } from "react-toastify";

export default function SafetyMessageHistory() {
    const [messages, setMessages] = useState([])

    function getAllMessages() {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch("/api/drivers/messages/get",
            {
                headers: myHeaders,
                method: 'GET'
            }
        ).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            setMessages(data)
        }).catch((e) => {
            toast.error(e, {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored",
            })
        })
    }

    function deleteMessage(messageId) {
        // create the headers for the fetch 
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        fetch(`/api/safety/message/${messageId}/delete`,
            {
                headers: myHeaders,
                method: 'POST'
            }
        ).then((res) => {
            if (res.ok) {
                toast.success("Message deleted!", {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored",
                })
                getAllMessages()
            } else {
                throw new Error()
            }
        }).catch((e) => {
            toast.error(e, {
                closeButton: true,
                autoClose: true,
                position: toast.POSITION.BOTTOM_CENTER,
                theme: "colored",
            })
        })
    }

    useEffect(() => {
        getAllMessages()
    }, [])

    return (
        <CCard classname="mb-4">
            <CCardBody>
                <CCardTitle className='fs-2'>Message History</CCardTitle>
                {/* Active messages */}
                <CCardTitle className='fs-4' style={{ marginTop: '30px', color: '#61B165' }}>Current</CCardTitle>
                <SafetyMessage messages={messages.filter((m) => new Date(m.expiry) > new Date())} hasDeleteButton={true} deleteMessage={deleteMessage} />
                {/* Historical messages */}
                <CCardTitle className='fs-4' style={{ marginTop: '30px' }}>Past</CCardTitle>
                <SafetyMessage messages={messages.filter((m) => new Date(m.expiry) <= new Date())} hasDeleteButton={true} deleteMessage={deleteMessage} />
            </CCardBody>
        </CCard>
    )
}